import { Selector, State } from "./types";
import { projectElementDetailsConfiguration } from "@planzone/dto";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveProjectElementDetailsConfigurationRequestFailure({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRetrieveProjectElementDetailsConfigurationRequestPending({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRetrieveProjectElementDetailsConfigurationRequestSuccess({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
    getProjectElementDetailsConfiguration({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.configuration : projectElementDetailsConfiguration;
    },
  };
}

export { createSelector };
